var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 46,
    viewBox: "0 0 58 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5005,
    cy: 22.5,
    r: 20.5,
    fill: "black",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 37C29.9563 37 36.0005 30.9558 36.0005 23.5C36.0005 16.0442 29.9563 10 22.5005 10C15.0447 10 9.00049 16.0442 9.00049 23.5C9.00049 30.9558 15.0447 37 22.5005 37Z",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5006 28.9C25.4829 28.9 27.9006 26.4823 27.9006 23.5C27.9006 20.5176 25.4829 18.1 22.5006 18.1C19.5183 18.1 17.1006 20.5176 17.1006 23.5C17.1006 26.4823 19.5183 28.9 22.5006 28.9Z",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3208 27.3204L32.0448 33.0444",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9561 33.0444L18.6801 27.3204",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3208 19.6796L32.0448 13.9556",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3208 19.6796L31.0863 14.9141",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9561 13.9556L18.6801 19.6796",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group 22.ebe2f7b4c0d63920feb40918a6f8e5b6.svg";
export { ForwardRef as ReactComponent };